module.exports = require('./helpers/bundle-url').getBundleURL('jFbuv') + "logo-dark.eefe0b7f.svg";